import {OrderStatus} from "../components";
import moment from "moment/moment";
import {keyBy, isEqual} from "lodash";

export const OrderShortcutFilterValues = {
    PENDING: "pending",
    ACCEPTED: "accepted",
    SUPPLY_TOMORROW: "supplyTomorrow",
    CANCELLED_ORDER: "cancelledOrder",
    TODAY_ORDERS: "todayOrders",
    SUPPLY_TODAY: "supplyToday",
    OPEN_ISSUES: "openIssues",
    RATED: "ratedOrders"
};

export const OrderShortcutToText = {
    [OrderShortcutFilterValues.PENDING]: "ממתין לאישור",
    [OrderShortcutFilterValues.ACCEPTED]: "הזמנות מאושרות",
    [OrderShortcutFilterValues.SUPPLY_TOMORROW]: "אספקות למחר",
    [OrderShortcutFilterValues.CANCELLED_ORDER]: "הזמנות שסורבו/בוטלו",
    [OrderShortcutFilterValues.TODAY_ORDERS]: "הזמנות של היום",
    [OrderShortcutFilterValues.SUPPLY_TODAY]: "אספקות של היום",
    [OrderShortcutFilterValues.OPEN_ISSUES]: "הזמנות עם תקלה",
    [OrderShortcutFilterValues.RATED]: "הזמנות שדורגו"
};

export const OrdersShortcuts = [
    {
        key: OrderShortcutFilterValues.PENDING,
        label: OrderShortcutToText[OrderShortcutFilterValues.PENDING],
        value: OrderShortcutFilterValues.PENDING,
        statuses: [OrderStatus.pending],
        searchByCreated: false,
        datePicked: () => [moment().startOf("day"), moment().add(2, "months").endOf("day")],
        isChecked: ({statuses}) => isEqual(statuses, [OrderStatus.pending])
    },
    {
        key: OrderShortcutFilterValues.ACCEPTED,
        label: OrderShortcutToText[OrderShortcutFilterValues.ACCEPTED],
        value: OrderShortcutFilterValues.ACCEPTED,
        statuses: [OrderStatus.accepted],
        searchByCreated: false,
        datePicked: () => [moment().startOf("month"), moment().endOf("month")],
        isChecked: ({statuses}) => isEqual(statuses, [OrderStatus.accepted])
    },
    {
        key: OrderShortcutFilterValues.CANCELLED_ORDER,
        label: OrderShortcutToText[OrderShortcutFilterValues.CANCELLED_ORDER],
        value: OrderShortcutFilterValues.CANCELLED_ORDER,
        statuses: [OrderStatus.cancelled, OrderStatus.declined],
        searchByCreated: true,
        datePicked: () => [moment().startOf("month"), moment().endOf("month")],
        isChecked: ({statuses}) => isEqual(statuses, [OrderStatus.cancelled, OrderStatus.declined])
    },
    {
        key: OrderShortcutFilterValues.TODAY_ORDERS,
        label: OrderShortcutToText[OrderShortcutFilterValues.TODAY_ORDERS],
        value: OrderShortcutFilterValues.TODAY_ORDERS,
        searchByCreated: true,
        datePicked: () => [moment().startOf("day"), moment().endOf("day")],
        isChecked: ({searchDate, searchByCreated}) =>
            searchByCreated === true &&
            searchDate.length > 1 &&
            moment()?.diff(searchDate?.[0], "days") === 0 &&
            moment()?.diff(searchDate?.[1], "days") === 0
    },
    {
        key: OrderShortcutFilterValues.SUPPLY_TODAY,
        label: OrderShortcutToText[OrderShortcutFilterValues.SUPPLY_TODAY],
        value: OrderShortcutFilterValues.SUPPLY_TODAY,
        statuses: [OrderStatus.accepted, OrderStatus.pending],
        searchByCreated: false,
        datePicked: () => [moment().startOf("day"), moment().endOf("day")],
        isChecked: ({searchDate, searchByCreated, statuses}) =>
            searchByCreated === false &&
            isEqual(statuses, [OrderStatus.accepted, OrderStatus.pending]) &&
            searchDate.length > 1 &&
            moment()?.diff(searchDate?.[0], "days") === 0 &&
            moment()?.diff(searchDate?.[1], "days") === 0
    },
    {
        key: OrderShortcutFilterValues.SUPPLY_TOMORROW,
        label: OrderShortcutToText[OrderShortcutFilterValues.SUPPLY_TOMORROW],
        value: OrderShortcutFilterValues.SUPPLY_TOMORROW,
        statuses: [OrderStatus.accepted, OrderStatus.pending],
        searchByCreated: false,
        datePicked: () => [moment().add(1, "day").startOf("day"), moment().add(1, "day").endOf("day")],
        isChecked: ({searchDate, searchByCreated, statuses}) =>
            searchByCreated === false &&
            isEqual(statuses, [OrderStatus.accepted, OrderStatus.pending]) &&
            searchDate?.length > 1 &&
            searchDate?.[0]?.endOf("day")?.diff(moment(), "days") === 1 &&
            searchDate?.[0]?.endOf("day")?.diff(moment(), "days") === 1
    }
];

export const OpenIssuesShortcut = {
    key: OrderShortcutFilterValues.OPEN_ISSUES,
    label: OrderShortcutToText[OrderShortcutFilterValues.OPEN_ISSUES],
    value: OrderShortcutFilterValues.OPEN_ISSUES,
    searchByCreated: false,
    datePicked: () => [moment().subtract(30, "days").startOf("day"), moment().endOf("day")],
    isChecked: ({openIssuedOrders}) => openIssuedOrders === true
};

export const RatedShortcut = {
    key: OrderShortcutFilterValues.RATED,
    label: OrderShortcutToText[OrderShortcutFilterValues.RATED],
    value: OrderShortcutFilterValues.RATED,
    statuses: [OrderStatus.accepted],
    searchByCreated: false,
    datePicked: () => [moment().subtract(30, "days").startOf("day"), moment().endOf("day")],
    isChecked: ({statuses, ratedOrders}) => isEqual(statuses, [OrderStatus.accepted]) && ratedOrders === true
};

export const OrdersShortcutsSettingsMap = keyBy(OrdersShortcuts, s => s.key);

export const ORDER_SHORTCUT_SUMMARY_ROOM = "order-shortcut-summary";
export const ORDER_SHORTCUT_SUMMARY_UPDATED_EVENT = "ORDER_SHORTCUT_SUMMARY_UPDATED";
